import { formatDate, addMonths, lastDayOfMonth, transformDate } from '@/utils/date'
import http from '@/utils/http'

const initialState = () => ({
  monthlyRecords: [],
  dailyRecords: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_MONTHLY (state, list = []) {
    state.monthlyRecords = list.map(item => {
      const fullDate = transformDate(item.Key, false)
      return {
        year: formatDate(fullDate, 'YYYY'),
        month: formatDate(fullDate, 'MMMM'),
        monthNumber: formatDate(fullDate, 'M'),
        count: item.Value
      }
    })
  },
  SET_DAILY (state, list = []) {
    state.dailyRecords = list
  }
}

export const getters = {
  monthlyRecords: state => state.monthlyRecords,
  dailyRecords: state => state.dailyRecords,
  getByType: state => type => state[`${type}Records`]
}

export const actions = {
  fetchMonthlyRecords ({ commit, rootGetters }, { startDate = null, endDate = null } = {}) {
    if (!startDate || !endDate) {
      if (!endDate) {
        endDate = new Date()
      }

      if (!startDate) {
        startDate = addMonths(endDate, -11)
      }

      startDate = formatDate(startDate, 'YYYY-MM') + '-01'
      endDate = formatDate(endDate, 'YYYY-MM') + `-${lastDayOfMonth(endDate)}`
    }

    const [startYear, startMonth, startDay] = startDate.split('-')
    const [endYear, endMonth, endDay] = endDate.split('-')

    return http({
      url: `${process.env.VUE_APP_API_URL}DAS/records/monthly/countbycustomer/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${startYear}/${startMonth}/${startDay}/${endYear}/${endMonth}/${endDay}`
    }).then(data => {
      commit('SET_MONTHLY', data)

      return data
    })
  },
  fetchDailyRecords ({ commit, rootGetters }, { year, monthNumber }) {
    if (!year || !monthNumber) {
      throw new Error('recordStatistics')
    }

    return http({
      url: `${process.env.VUE_APP_API_URL}DAS/records/daily/countbycustomer/${rootGetters['auth/token']}/${rootGetters['customers/customerGuid']}/${year}/${monthNumber}`
    }).then(data => {
      commit('SET_DAILY', data)

      return data
    })
  }
}
